import React from 'react';
import { useLocalStore, useObserver } from 'mobx-react-lite';
import { ScoreDetailService } from '../../../../../common/services';
import WebSocketUtil from '../../../../../common/utils/socketUtil';
import { _SPORTS_WS_TOPIC } from '../../../../../common/constants/sportsConstants';
import { computed, observable, runInAction, toJS, values } from 'mobx';
import SoccerModel from '../../../soccer/store/model';
import BaseballModel from '../../../baseball/store/model';
import BasketballModel from '../../../basketball/store/model';
import VolleyballModel from '../../../volleyball/store/model';
import HockeyModel from '../../../hockey/store/model';
import FootballModel from '../../../football/store/model';
import { getConcatList, deleteFinishGame } from '../../../major/store/util';
import moment from 'moment';
import TennisModel from "routes/score/tennis/store/model";

const HotMatchStore = () => {
  let store = useLocalStore(() => ({
    matches: {
      loading: false,
      data: null
    },
    sportsView: {
      soccer: [],
      baseball: [],
      basketball: [],
      volleyball: [],
      hockey: [],
      football: [],
      tennis: []
    },
    socket: null,
    async getMatches() {
      store.matches.loading = true;
      try {
        if (!this.isSub) {
          this.connectSocket(
            [
              ..._SPORTS_WS_TOPIC['soccer'],
              ..._SPORTS_WS_TOPIC['baseball'],
              ..._SPORTS_WS_TOPIC['basketball'],
              ..._SPORTS_WS_TOPIC['volleyball'],
              ..._SPORTS_WS_TOPIC['hockey'],
              ..._SPORTS_WS_TOPIC['football'],
              ..._SPORTS_WS_TOPIC['tennis']
            ].map((item) => item.topic)
          );
        }

        const result = await ScoreDetailService.getHotGames();

        let copySportsView = { ...this.sportsView };

        Object.keys(result).forEach((key) => {
          if (key !== 'tennis') {
            copySportsView[key] = result[key].map((item) => {
              if (key === 'soccer') {
                return new SoccerModel(item);
              } else if (key === 'baseball') {
                return new BaseballModel(item);
              } else if (key === 'basketball') {
                return new BasketballModel(item);
              } else if (key === 'volleyball') {
                return new VolleyballModel(item);
              } else if (key === 'hockey') {
                return new HockeyModel(item);
              } else if (key === 'football') {
                return new FootballModel(item);
              } else if (key === 'tennis') {
                return new TennisModel(item);
              }
            });
          }
        });

        store.matches.data = getConcatList(
          deleteFinishGame(copySportsView),
          'major'
        );
      } catch (e) {
        console.log(e);
      }
      store.matches.loading = false;
    },
    connectSocket(topic, type = null) {
      store.socket = new WebSocketUtil(topic);

      store.socket.ws.onmessage = (event) => {
        if (event) {
          let data = event.data;

          try {
            if (data === 'OK') {
              this.isSub = true;
            } else {
              let messageData = JSON.parse(data);

              if (messageData) {
                const { TOPIC, MESSAGE } = messageData;

                if (TOPIC.includes('sports')) {
                  const data = JSON.parse(MESSAGE);
                  const { sportsView } = store;
                  const sportsTypeKeyArr = Object.keys(sportsView);
                  let index = -1;

                  if (TOPIC.includes('cheers')) {
                    sportsTypeKeyArr.forEach((key) => {
                      if (data.hasOwnProperty('game_id')) {
                        index = sportsView[key].findIndex(
                          (item) => item.id === parseInt(data.game_id)
                        );
                      }
                      if (Boolean(~index)) {
                        sportsView[key][index].cheerCount++;
                      }
                    });
                  } else {
                    sportsTypeKeyArr.forEach((key) => {
                      if (data.hasOwnProperty('gameId')) {
                        index = sportsView[key].findIndex(
                          (item) => item.id === data.gameId
                        );
                      }

                      if (TOPIC.includes(key)) {
                        [
                          ..._SPORTS_WS_TOPIC['soccer'],
                          ..._SPORTS_WS_TOPIC['baseball'],
                          ..._SPORTS_WS_TOPIC['basketball'],
                          ..._SPORTS_WS_TOPIC['volleyball'],
                          ..._SPORTS_WS_TOPIC['hockey'],
                          ..._SPORTS_WS_TOPIC['football'],
                          ..._SPORTS_WS_TOPIC['tennis']
                        ].forEach((item) => {
                          if (TOPIC === `${item.topic}`) {
                            if (Boolean(~index)) {
                              if (TOPIC.includes('games')) {
                                if (
                                  key === 'basketball' ||
                                  key === 'volleyball'
                                ) {
                                  sportsView[key][index][item.funcName](
                                    data[item.key],
                                    check,
                                    checkFavorite
                                  );
                                } else {
                                  sportsView[key][index][item.funcName](
                                    data[item.key]
                                  );
                                }
                              } else if (TOPIC.includes('period-data')) {
                                if (
                                  key === 'basketball' ||
                                  key === 'volleyball'
                                ) {
                                  sportsView[key][index][item.funcName](
                                    data[item.key]
                                  );
                                } else {
                                  sportsView[key][index][item.funcName](
                                    data[item.key],
                                    check,
                                    checkFavorite
                                  );
                                }
                              } else {
                                sportsView[key][index][item.funcName](
                                  data[item.key]
                                );
                              }
                            }
                          }
                        });
                      }
                    });
                  }
                }
              }
            }
          } catch (error) {
            console.log('=== socket on message error ===', error);
          }
        }
      };
    },
    closeSocket() {
      if (!!store.socket) {
        store.socket.close(() => {
          runInAction(() => {
            this.isSub = false;
            store.socket = null;
          });
        });
      }
    },
    get matchList() {
      const result = [];
      if (store.matches.data !== null) {
        if (store.matches.data.length > 0) {
          let dateMatch = null;

          store.matches.data.map((match) => {
            const { startDatetime } = match;

            const formattedTime = moment(startDatetime).format('YYYY-MM-DD');

            dateMatch =
              result.find((value) => value.date === formattedTime) || null;

            if (dateMatch !== null) {
              dateMatch.games.push(match);
            } else {
              dateMatch = {
                date: formattedTime,
                games: [match]
              };
              result.push(dateMatch);
            }
          });

          result.sort((a, b) => {
            const aDate = new Date(a.date);
            const bDate = new Date(b.date);
            if (aDate.getTime() > bDate.getTime()) return 1;
            if (aDate.getTime() < bDate.getTime()) return -1;
          });
        }
      }
      return result;
    }
  }));

  return useObserver(() => {
    return {
      matches: store.matches,
      getMatches: store.getMatches,
      closeSocket: store.closeSocket,
      hotMatches: store.hotMatches,
      matchList: store.matchList
    };
  });
};

export default HotMatchStore;
